import React, {useEffect, useState} from 'react';
import {locationNotAvailable} from './constants';
import MultiSelectWithCheckBox from '../../../../../Multi-Select';
import {
  filterTimeSlotsByProviderLocation,
  arrangeUniqTimeSlots,
  isAvailableSlot
} from './utils';

export const MultiSelectWrapper = (props) => {
  const { listOfSelectedLocations, options, handleLocationChange, appointmentTypeId, selectedDay, timeSlots, timeZone} = props;
  const [selectedLocations, setSelectedLocations] = useState([]);

  useEffect(() => {
    if (selectedDay) {
      const filterData = options.filter(
        (location) => getTimeSlotsCount(parseInt(location.value)) > 0
      );
  
      setSelectedLocations([...filterData]);
    } else {
      setSelectedLocations([...options]);
    }
  }, [selectedDay, options]);

  
  const getTimeSlotsCount = (locationId) => {
    let fullDaytimeSlots = timeSlots || [];
    const locationTimeSlots = filterTimeSlotsByProviderLocation(
      fullDaytimeSlots,
      [locationId]
    );
    fullDaytimeSlots = arrangeUniqTimeSlots(locationTimeSlots, null, timeZone);
    fullDaytimeSlots = fullDaytimeSlots.filter(
      (slot) => isAvailableSlot(slot.time, timeZone)
    );
    return fullDaytimeSlots.length;
  };
  const handleCloseMultiSelect = (locations) => {
    handleLocationChange(locations);
  };
  
  return (
    <div>
      {selectedLocations && selectedLocations?.length > 0 && (
        <MultiSelectWithCheckBox
          options={selectedLocations}
          defaultValue="all"
          closeSelect={handleCloseMultiSelect}
          listOfSelectedLocations={listOfSelectedLocations}
        />
      )}

      { appointmentTypeId && selectedDay &&  selectedLocations.length <= 0 && (
        appointmentTypeId &&  locationNotAvailable
      )}
    </div>
  );
};

export default MultiSelectWrapper;
